var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isFetching && _vm.items.length)?_c('CarouselWrapper',{attrs:{"products":_vm.items,"title":_vm.$t('title'),"subtitle":_vm.$t('subtitle')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }